import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {HttpErrorResponse} from "@angular/common/http";
import {InspectionOrder} from "../../../classes/inspectionOrder";
import {InspectionOrderService} from "../../../services/inspectionOrder";
import {InspectionService} from "../../../services/inspection";
import {Inspection} from "../../../classes/inspection";

@Component({
  selector: 'app-inspection-order-create',
  templateUrl: './inspection-order-create.component.html',
  styleUrls: ['./inspection-order-create.component.css']
})
export class InspectionOrderCreateComponent implements OnInit {

  inspection = new Inspection();
  inspectionOrder = new InspectionOrder();
  inspectionOrderCreationResult = true;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private modalService: NgbModal,
              private inspectionService: InspectionService,
              private inspectionOrderService: InspectionOrderService) { }

  ngOnInit(): void {
      this.route.paramMap.subscribe(params => {
          this.inspectionService.getByID(params.get('id'))
              .subscribe({
                  next: (inspection: any) => {
                      this.inspection = inspection;
                  },
                  error: (err: HttpErrorResponse) => {
                      console.log(err);
                  }
              });
      });
  }

  onSubmit() {
    this.inspectionOrder.fk_id_inspection = this.inspection.id_inspection!;
    this.inspectionOrderService.create(this.inspectionOrder)
        .subscribe({
          next: () => {
            this.router.navigate(['/inspection/' + this.inspection.id_inspection]);
          },
          error: (err: HttpErrorResponse) => {
            this.inspectionOrderCreationResult = false;
            console.log(err);
          }
        });
  }

}
